module.exports = __webpack_public_path__ + "img/face-recognition-failed.d53cb415.png";